<template>
  <div class="gameList">
      <table class="table table-hover table-sm mt-2">
        <thead>
          <tr>
            <th>Nom</th>
            <th class="text-end">Créateur</th>
            <th class="text-end">Tour</th>
            <th class="text-end">Début</th>
            <th class="text-end">Fin</th>
            <th class="text-end">Joueurs</th>
            <th class="text-end">Temps par tour</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <access-game-list-row v-for="game in games"
          v-bind:key="game.id"
          v-bind:players="getGamePlayers(game.id)"
          v-bind:game="game"/>
        </tbody>
      </table>
  </div>
</template>

<script>
import AccessGameListRow from './AccessGameListRow.vue';

export default {
  name: 'AccessGameList',
  components: { AccessGameListRow },
  props: {
    games: {
      type: Array,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      gamePassword: undefined,
    };
  },
  methods: {
    getGamePlayers(activeGameId) {
      return this.players.filter(p => p.activeGameId === activeGameId);
    },
  },
};
</script>

<style scoped>
.gameList{
  background-color: white;
}
th{
  color: #757575;
}
</style>
